import { Befehl32 } from '../../../models'
import {
  Befehl32DataDto,
  BefehlAuftrag_32_10Dto,
  Feld_32_11Dto
} from '../../../dtos/befehl-32-dto'
import {
  Befehl32FormData,
  Befehl32FormSchema
} from './schema/befehl32-form.schema'
import { findAuftragByKennung, createField } from '../converter-utils'

export const convertModelToBefehl32FormData = (
  befehl?: Befehl32
): Befehl32FormData => {
  const formData = Befehl32FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag32_10 = findAuftragByKennung(
    befehl.auftraege,
    '32.10'
  ) as BefehlAuftrag_32_10Dto

  if (!auftrag32_10) {
    return formData
  }
  const feld32_11 = auftrag32_10.felder?.find(
    (feld) => feld.kennung === '32.11'
  ) as Feld_32_11Dto

  if (feld32_11?.werte?.signalUsw) {
    formData.auftrag_32_10.signalUsw = feld32_11.werte.signalUsw
  }

  return formData
}

export const convertBefehl32FormDataToModel = (
  formData: Befehl32FormData,
  frontendId: string
): Befehl32 => {
  const auftraege: Befehl32DataDto = []

  if (formData.auftrag_32_10?.enabled) {
    auftraege.push({
      kennung: '32.10',
      felder: [
        createField('32.11', {
          signalUsw: formData.auftrag_32_10?.signalUsw || ''
        })
      ]
    } as BefehlAuftrag_32_10Dto)
  }

  return {
    kennung: '32',
    frontendId,
    auftraege
  }
}
